





















































// @ts-nocheck
import Vue from 'vue';
import {getTripType, toggleTripType} from '@/store/state/helpers';
import {FilterTag} from '@/views/amex/app-types';
import {ButtonTypes} from '@common/button/button.vue';
import {TripWayTypes} from '@/views/amex/app-types';
import {fetchAdditionalPois} from '@/store/api/fetch-additional-pois';
import {RecommendationsContextWithOffers} from '@/views/amex/app-types';
import Alert from '@common/alert.vue';
import FilterInput from './filter-input.vue';
import DateSelector from './date-selector.vue';
import SubmitMessageButton from '@common/button/submit-message-button.vue';
import SectionHeader from '@components/discovery-page/section-header/section-header.vue';

import {
  DateRange,
  TripPartInfo,
  createTripPartInfo,
  setMinDatesAndValidateDates,
  getTripDateRangeStr,
} from './trip-inputs-helper';

export default Vue.extend({
  name: 'TripInputs',
  components: {
    FilterInput,
    DateSelector,
    Alert,
    SubmitMessageButton,
    SectionHeader,
  },
  props: {
    timeframe: {
      type: String,
      default: '',
    },
    startDate: Number,
    endDate: Number,
    travelers: {
      type: String,
      default: '',
    },
    origin: {
      type: [Object, String],
      default: () => '',
    },
    destination: {
      type: [Object, String],
      default: () => '',
    },
    isPreferencesFilledPopoverDisplayed: Boolean,
    selectedTags: {
      type: Array,
      default: () => [],
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      primaryDestination: {
        name: 'Singapore',
        display_name: 'Singapore',
        category: 'CITY',
        id: 'ffcb602a-96e3-331f-953f-fb8876d86d87',
        lat: 1.29378,
        lng: 103.853256,
        type: 'city',
      },
      tripDestinations: [createTripPartInfo()] as TripPartInfo[],
      filtersExpanded: false,
      ButtonTypes,
      isShowPreferencesPopover: false,
    };
  },
  computed: {
    isFindBtnDisabled(): boolean {
      return !this.primaryDestination;
    },

    tripWayType(): string {
      return getTripType();
    },

    dateRangeMode(): boolean {
      return this.tripWayType === TripWayTypes.roundTrip;
    },

    formatShortDateRange(): string {
      return getTripDateRangeStr(this.tripDestinations);
    },

    preferencesNum(): number {
      return this.selectedTags ? this.selectedTags?.length : 0;
    },

    preferences(): string {
      return this.selectedTags?.length
        ? (this.selectedTags as FilterTag[]).map((tag) => tag.name).join(', ')
        : 'No Preferences';
    },
    formatPreferencesNumStr(): string {
      if (this.preferencesNum === 0) {
        return 'No Preferences';
      }

      return this.preferencesNum > 1 ? `${this.preferencesNum} Preferences` : `${this.preferencesNum} Preference`;
    },

    tripInfo(): TripPartInfo {
      return this.tripDestinations[0];
    },
  },
  mounted() {
    toggleTripType(TripWayTypes.roundTrip);
    this.onPrimaryDestSelect();

    this.tripDestinations[0].origin = this.primaryDestination;
  },
  methods: {
    onBuildBtnClick() {
      this.$emit('build-trip', this.tripDestinations);
    },

    async onPrimaryDestSelect() {
      const value = {
        name: 'Singapore',
        display_name: 'Singapore',
        category: 'CITY',
        id: 'ffcb602a-96e3-331f-953f-fb8876d86d87',
        lat: 1.29378,
        lng: 103.853256,
        type: 'city',
      };
      this.primaryDestination = value;
      this.tripDestinations[0].destination = this.primaryDestination;

      await this.fetchPlaceInfo(value.id, 0);
    },

    async fetchPlaceInfo(placeId: string, index: number) {
      const placeInfo: RecommendationsContextWithOffers[] = await fetchAdditionalPois([placeId]);

      // set image
      if (placeInfo && placeInfo.length) {
        Vue.set(this.tripDestinations[index], 'destinationImage', placeInfo[0].images.small);
      }
    },

    onDateSelect(dateRange: DateRange, index: number) {
      this.tripDestinations[index].dateRange = dateRange;
      this.$emit('dates-selected', dateRange);
      if (this.tripWayType === TripWayTypes.multiCity) {
        //@ts-ignore
        setMinDatesAndValidateDates(this.tripDestinations);
      }
    },
  },
});
